import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../../store/authStore';
import { loginService } from '../services/loginService';
import { authService } from '../../../services/authService';
import toast from 'react-hot-toast';

export const useLoginForm = () => {
  const navigate = useNavigate();
  const { login } = useAuthStore();
  const [email, setEmail] = useState('owner@spacedesigns.com');
  const [password, setPassword] = useState('Owner@123');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  // Captcha states
  const [captchaId, setCaptchaId] = useState('');
  const [captchaSvg, setCaptchaSvg] = useState('');
  const [captchaText, setCaptchaText] = useState('');
  const [actualCaptchaText, setActualCaptchaText] = useState('');

  const fetchCaptcha = async () => {
    try {
      const data = await authService.getCaptcha();
      setCaptchaId(data.captchaId);
      setCaptchaSvg(data.captchaSvg);
      setActualCaptchaText(data.captchaText);
      setCaptchaText('');
    } catch (error) {
      toast.error('Failed to load CAPTCHA');
    }
  };

  useEffect(() => {
    fetchCaptcha();
  }, []);

  // Store selection states
  const [needsStoreSelection, setNeedsStoreSelection] = useState(false);
  const [availableStores, setAvailableStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState('');

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    if (!captchaText && !needsStoreSelection) {
      toast.error('Please enter the CAPTCHA');
      return;
    }

    if (needsStoreSelection && !selectedStore) {
      toast.error('Please select a store to continue');
      return;
    }

    setLoading(true);
    try {
      const payload = { email, password, captchaId, captchaText };
      if (selectedStore) payload.storeId = selectedStore;

      const res = await loginService.executeLogin(payload);
      
      if (res.needsStoreSelection) {
        setNeedsStoreSelection(true);
        setAvailableStores(res.authorizedStores || []);
        if (res.authorizedStores && res.authorizedStores.length > 0) {
          setSelectedStore(res.authorizedStores[0]._id);
        }
      } else if (res.success) {
        setCaptchaId('');
        setCaptchaSvg('');
        setCaptchaText('');
        setActualCaptchaText('');
        setNeedsStoreSelection(false);
        setAvailableStores([]);
        login(res.data, res.token);
        toast.success(`Welcome back, ${res.data.name || res.data.firstName}!`);
        navigate('/home');
      } else {
        toast.error(res.message || 'Login failed');
        await fetchCaptcha();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Invalid email, password, or CAPTCHA');
      if (error.response?.data?.message?.includes('CAPTCHA')) {
        setNeedsStoreSelection(false);
      }
      await fetchCaptcha();
    } finally {
      setLoading(false);
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    loading,
    showPass,
    setShowPass,
    captchaText,
    setCaptchaText,
    captchaSvg,
    actualCaptchaText,
    fetchCaptcha,
    handleLogin,
    needsStoreSelection,
    availableStores,
    selectedStore,
    setSelectedStore
  };
};




